import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_LOAD_BY_INSTITUTION_ID,
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_LOAD_BY_ID,

    ACTION_INSTITUTIONCONFIDENTIALITYDEED_SAVE,

    ACTION_INSTITUTIONCONFIDENTIALITYDEED_CREATE,

    ACTION_INSTITUTIONCONFIDENTIALITYDEED_DELETE,

    ACTION_INSTITUTIONCONFIDENTIALITYDEED_VALIDATE,

    IInstitutionConfidentialityDeedLoadByInstitutionIdAction,
    IInstitutionConfidentialityDeedLoadByIdAction,
    IInstitutionConfidentialityDeedLoadFailureAction,
    IInstitutionConfidentialityDeedLoadSuccessAction,

    IInstitutionConfidentialityDeedSaveAction,
    IInstitutionConfidentialityDeedSaveSuccessAction,
    IInstitutionConfidentialityDeedSaveFailureAction,

    IInstitutionConfidentialityDeedCreateAction,
    IInstitutionConfidentialityDeedCreateSuccessAction,
    IInstitutionConfidentialityDeedCreateFailureAction,

    IInstitutionConfidentialityDeedDeleteAction,
    IInstitutionConfidentialityDeedDeleteSuccessAction,
    IInstitutionConfidentialityDeedDeleteFailureAction,

    IInstitutionConfidentialityDeedValidateAction,
    IInstitutionConfidentialityDeedValidateSuccessAction,
    IInstitutionConfidentialityDeedValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    DeleteSuccess,
    DeleteFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/institutionConfidentialityDeed";
import { institutionConfidentialityDeedApi } from "../services/institutionConfidentialityDeed";

export const
    getInstitutionConfidentialityDeedByInstitutionIdEpic = (action$): Observable<IInstitutionConfidentialityDeedLoadSuccessAction | IInstitutionConfidentialityDeedLoadFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONCONFIDENTIALITYDEED_LOAD_BY_INSTITUTION_ID)
            .mergeMap((action: IInstitutionConfidentialityDeedLoadByInstitutionIdAction) => {
                return institutionConfidentialityDeedApi
                    .getInstitutionConfidentialityDeedByInstitutionId(action.institutionId)
                    .map(response =>
                        LoadSuccess(response.institutionConfidentialityDeed, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getInstitutionConfidentialityDeedByIdEpic = (action$): Observable<IInstitutionConfidentialityDeedLoadSuccessAction | IInstitutionConfidentialityDeedLoadFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONCONFIDENTIALITYDEED_LOAD_BY_ID)
            .mergeMap((action: IInstitutionConfidentialityDeedLoadByIdAction) => {
                return institutionConfidentialityDeedApi
                    .getInstitutionConfidentialityDeedById(action.id)
                    .map(response =>
                        LoadSuccess(response.institutionConfidentialityDeed, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setInstitutionConfidentialityDeedEpic = (action$): Observable<IInstitutionConfidentialityDeedSaveSuccessAction | IInstitutionConfidentialityDeedSaveFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONCONFIDENTIALITYDEED_SAVE)
            .mergeMap((action: IInstitutionConfidentialityDeedSaveAction) => {
                return institutionConfidentialityDeedApi
                    .setInstitutionConfidentialityDeed(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.institutionConfidentialityDeed, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createInstitutionConfidentialityDeedEpic = (action$): Observable<IInstitutionConfidentialityDeedCreateSuccessAction | IInstitutionConfidentialityDeedCreateFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONCONFIDENTIALITYDEED_CREATE)
            .mergeMap((action: IInstitutionConfidentialityDeedCreateAction) => {
                return institutionConfidentialityDeedApi
                    .createInstitutionConfidentialityDeed(action.institutionId)
                    .map(response =>
                        CreateSuccess(
                            response.institutionConfidentialityDeed,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    deleteInstitutionConfidentialityDeedEpic = (action$): Observable<IInstitutionConfidentialityDeedDeleteSuccessAction | IInstitutionConfidentialityDeedDeleteFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONCONFIDENTIALITYDEED_DELETE)
            .mergeMap((action: IInstitutionConfidentialityDeedDeleteAction) => {
                return institutionConfidentialityDeedApi
                    .deleteInstitutionConfidentialityDeed(action.id)
                    .map(_response =>
                        DeleteSuccess()
                    )
                    .catch(error =>
                        Observable.of(DeleteFailure(error.responseStatus))
                    )
            });
    },
    validateInstitutionConfidentialityDeedEpic = (action$): Observable<IInstitutionConfidentialityDeedValidateSuccessAction | IInstitutionConfidentialityDeedValidateFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONCONFIDENTIALITYDEED_VALIDATE)
            .mergeMap((action: IInstitutionConfidentialityDeedValidateAction) => {
                return institutionConfidentialityDeedApi
                    .validateInstitutionConfidentialityDeed(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.institutionConfidentialityDeed, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }